import { getPermissions } from './getPermissions';

export const hasPermission = state => type => {
  const perms = getPermissions(state);
  if (!perms.length) {
    return undefined;
  }
  return !!getPermissions(state).find(perm => perm.permission === type);
};
